import { cn } from '#app/utils/misc.tsx'
interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
	className?: string
}

export function Container({ className, ...props }: ContainerProps) {
	return (
		<div
			className={cn(
				'mx-auto max-w-7xl items-center px-4 sm:px-6 lg:px-8',
				className,
			)}
			{...props}
		/>
	)
}
